<template>
  <el-loading-wrapper
    :loading="loading"
    :loading-text="loadingText"
  >
    <el-tabs>
      <el-tab-pane label="Notes Edit">
        <el-switch
          v-model="lockingEnabled"
          active-text="Enable Notes Editing"
          class="u-mb2 u-mt2"
          @change="switchChangesHandler"
          data-element="toggle-locking"
        />
          <p v-if="switchIsOn">
            Enable notes editing for up to
            <el-input-number
              v-model="lockingPeriod"
              :min="1"
              :max="48"
              size="mini"
              class="u-ml2 u-mr2 u-mb2"
              data-element="lock-note-hour"
            />
            hour(s) after creation.
          </p>
          <p v-else>
            All new notes by default will be locked immediately after being saved.
          </p>
          <div>
            <el-button
              class="u-mt2"
              v-test-id="'save-button'"
              type="primary"
              @click="saveNoteSettings">
              Save
            </el-button>
          </div>
      </el-tab-pane>
    </el-tabs>
  </el-loading-wrapper>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: 'NotesSettingsTabs',
  data () {
    return {
      lockingPeriod: null,
      lockingEnabled: null,
      loading: true,
      loadingText: '',
      switchIsOn: false
    }
  },
  async mounted () {
    this.loadingText = 'Loading settings...'
    await this.initializeForm()
    this.loading = false
  },
  computed: {
    ...mapGetters('notes', [
      'settingsRepository'
    ])
  },
  methods: {
    async initializeForm () {
      this.lockingPeriod = await this.fetchLockingPeriod()
      this.lockingEnabled = this.lockingPeriod !== 0
      this.switchIsOn = this.lockingEnabled
    },
    async fetchLockingPeriod () {
      const response = await this.settingsRepository.readRecord({id: 'locking_period'})
      return response.data.value
    },
    async saveNoteSettings () {
      this.loading = true
      this.loadingText = 'Saving settings...'
      try {
        // locking is always enabled just the period changes
        await this.settingsRepository.updateRecord({
          id: 'locking_enabled',
          data: {value: true}
        })
        await this.settingsRepository.updateRecord({
          id: 'locking_period',
          data: {value: this.lockingPeriod}
        })
      } finally {
        this.loading = false
      }
    },
    switchChangesHandler (state) {
      this.switchIsOn = state
      if (this.switchIsOn) {
        this.lockingPeriod = 1
      } else {
        this.lockingPeriod = 0
      }
    }
  }
}
</script>
